import React, { useState } from "react";

const GeneralAbility = (props) => {

    const abilityID = props.item.id;

    const [isExpanded, setIsExpanded] = useState(false);

    function minCount() {
        return props.item.freePoints;
    }

    let [count, setCount] = useState(
        props.item.id in props.pointMap ? props.pointMap[props.item.id] : minCount()
    );

    function updatePointMap(updatedCount) {
        const copyMap = structuredClone(props.pointMap);
        copyMap[props.item.id] = updatedCount;
        props.setPointMap(copyMap);
    }

    function incrementCount() {
        const updatedCount = props.pointsRemaining > 0 ? count + 1 : count;
        setCount(updatedCount);
        updatePointMap(updatedCount);        
    }

    function decrementCount() {
        const updatedCount = Math.max(minCount(), count - 1);
        setCount(updatedCount);
        updatePointMap(updatedCount);
    }

    // expand/collapse

    function toggleExpandDisplay() {
        setIsExpanded(!isExpanded);
    }

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    // classes

    const expandClasses = {
        'App-action-expandicon': true,
        'expand-icon--selected': isExpanded
    };

    const expandClassNames = classNames(expandClasses);

    const labelClasses = {
        'App--action-label': true,
        'App--action-label-expand': isExpanded
    };

    const labelClassNames = classNames(labelClasses);

    const descriptionClasses = {
        'App--action-desc': true,
        'App--action-desc-expand': isExpanded
    };

    const descriptionClassNames = classNames(descriptionClasses);

    const titleClasses = {
        'App--action-title-label': true,
        'App--action-title-label-expand': isExpanded
    };

    const titleClassNames = classNames(titleClasses);

    return (
        <div className="App--general-action-row">
            <button type="button" onClick={toggleExpandDisplay} className="App--general-action-button">
                <div id={"action-display-" + abilityID} className="App-action-expand-button">
                    <div className={expandClassNames} />
                </div>
                <div className={labelClassNames}>
                    <div className={titleClassNames} >{props.item.name}</div>
                    <div className={descriptionClassNames}>
                        {props.item.description}
                    </div>
                </div>
            </button>
            <div className="App--general-action-points-box">
                <button type="button" className="App--general-action-points-adjust-button"
                    onClick={decrementCount}
                    disabled={!props.canDecrement }>
                    <div className="App--general-action-points-adjust-button-text">
                        <img alt="minus" src="./minus-button.png" width="40px" />
                    </div>
                </button>
                <div className="App--general-action-points-text">
                    <div className="App--general-action-points-text-current">
                        {count}
                    </div>
                </div>
                <button type="button" className="App--general-action-points-adjust-button"
                    onClick={incrementCount}
                    disabled={!props.canIncrement}>
                    <div className="App--general-action-points-adjust-button-text">
                        <img alt="plus" src="./plus-button.png" width="40px" />
                    </div>
                </button>
            </div>
        </div>
    );
};

export default GeneralAbility;